import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, vModelText as _vModelText, withDirectives as _withDirectives, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "emp-documents-page" }
const _hoisted_2 = { class: "page-content" }
const _hoisted_3 = { class: "document-categories" }
const _hoisted_4 = { class: "card-icon contract" }
const _hoisted_5 = {
  key: 0,
  class: "card-badge"
}
const _hoisted_6 = { class: "card-icon payslip" }
const _hoisted_7 = {
  key: 0,
  class: "card-badge"
}
const _hoisted_8 = { class: "card-icon record" }
const _hoisted_9 = {
  key: 0,
  class: "card-badge"
}
const _hoisted_10 = { class: "card-icon certificate" }
const _hoisted_11 = { class: "card-arrow" }
const _hoisted_12 = { class: "card-icon resignation" }
const _hoisted_13 = {
  key: 0,
  class: "card-status"
}
const _hoisted_14 = {
  key: 0,
  class: "recent-documents"
}
const _hoisted_15 = { class: "section-title" }
const _hoisted_16 = { class: "document-list" }
const _hoisted_17 = ["onClick"]
const _hoisted_18 = { class: "doc-info" }
const _hoisted_19 = { class: "doc-name" }
const _hoisted_20 = { class: "doc-date" }
const _hoisted_21 = ["onClick"]
const _hoisted_22 = {
  key: 1,
  class: "empty-notice"
}
const _hoisted_23 = { class: "dialog-header" }
const _hoisted_24 = { class: "dialog-content" }
const _hoisted_25 = { key: 0 }
const _hoisted_26 = { class: "contract-info" }
const _hoisted_27 = { class: "contract-period" }
const _hoisted_28 = { class: "contract-type" }
const _hoisted_29 = { class: "contract-actions" }
const _hoisted_30 = ["onClick"]
const _hoisted_31 = ["onClick"]
const _hoisted_32 = {
  key: 1,
  class: "no-data"
}
const _hoisted_33 = { class: "dialog-header" }
const _hoisted_34 = { class: "dialog-content" }
const _hoisted_35 = { class: "certificate-options" }
const _hoisted_36 = { class: "cert-purpose" }
const _hoisted_37 = ["disabled"]
const _hoisted_38 = { key: 1 }
const _hoisted_39 = { class: "cert-notice" }
const _hoisted_40 = { class: "write-header" }
const _hoisted_41 = { class: "write-content" }
const _hoisted_42 = { class: "input-group" }
const _hoisted_43 = ["min"]
const _hoisted_44 = { class: "input-group" }
const _hoisted_45 = { class: "input-group" }
const _hoisted_46 = { class: "signature-box" }
const _hoisted_47 = { class: "info-notice" }
const _hoisted_48 = { class: "warning-notice" }
const _hoisted_49 = ["disabled"]
const _hoisted_50 = { class: "resignation-detail-header" }
const _hoisted_51 = {
  key: 0,
  class: "resignation-detail-content"
}
const _hoisted_52 = { class: "detail-info" }
const _hoisted_53 = { class: "info-row" }
const _hoisted_54 = { class: "info-value" }
const _hoisted_55 = { class: "info-row" }
const _hoisted_56 = { class: "info-value" }
const _hoisted_57 = { class: "info-row" }
const _hoisted_58 = { class: "info-value" }
const _hoisted_59 = { class: "info-row" }
const _hoisted_60 = { class: "info-value reason" }
const _hoisted_61 = { class: "info-row" }
const _hoisted_62 = { class: "info-value" }
const _hoisted_63 = { class: "info-row" }
const _hoisted_64 = { class: "info-value" }
const _hoisted_65 = {
  key: 2,
  class: "delete-notice"
}
const _hoisted_66 = { class: "confirm-content" }
const _hoisted_67 = { class: "confirm-actions" }
const _hoisted_68 = ["disabled"]
const _hoisted_69 = { key: 1 }

import { ref, computed, onMounted, nextTick, watch } from 'vue';
import { useStore } from 'vuex';
import { useRouter } from 'vue-router';
import axios from 'axios';


export default /*@__PURE__*/_defineComponent({
  __name: 'EmpDocuments',
  setup(__props) {

const store = useStore();
const router = useRouter();

// 사원 정보
const pwaUser = computed(() => store.getters['pwa/pwaUser']);
const empIdx = computed(() => pwaUser.value?.emp_idx || '');
const empCode = computed(() => pwaUser.value?.emp_code || '');
const sisulCode = computed(() => pwaUser.value?.m_sisul_code || '');
const sisulName = computed(() => pwaUser.value?.sisul_name || pwaUser.value?.m_sisul_name || '');
const empJob = computed(() => pwaUser.value?.emp_job || '');
const empName = computed(() => pwaUser.value?.emp_name || '');

// 요양보호사 여부
const isCaregiver = computed(() => {
  const job = empJob.value;
  return !job.includes('센터장') && !job.includes('사회복지사') && !job.includes('사무');
});

// 상태
const isLoading = ref(false);
const isRequesting = ref(false);
const isSubmitting = ref(false);
const isDeleting = ref(false);

// 문서 카운트
const documentCounts = ref({
  contract: 0,
  payslip: 0,
  record: 0
});

// 최근 문서
const recentDocuments = ref<any[]>([]);

// 근로계약서
const showContractDialog = ref(false);
const contracts = ref<any[]>([]);

// 증명서 발급
const showCertificateDialog = ref(false);
const selectedCertType = ref('');
const certPurpose = ref('');

// 사직서
const showResignationWriteDialog = ref(false);
const showResignationDetailDialog = ref(false);
const showDeleteConfirmDialog = ref(false);
const myResignation = ref<any>(null);
const resignationData = ref({
  reason: '',
  resignDate: ''
});

// 오늘 날짜
const today = new Date();
const todayFormatted = `${today.getFullYear()}년 ${today.getMonth() + 1}월 ${today.getDate()}일`;
const todayISO = `${today.getFullYear()}-${String(today.getMonth() + 1).padStart(2, '0')}-${String(today.getDate()).padStart(2, '0')}`;

// 최소 퇴사 희망일 (오늘 + 14일)
const minResignDate = computed(() => {
  const min = new Date();
  min.setDate(min.getDate() + 14);
  return min.toISOString().split('T')[0];
});

// 서명 캔버스
const signatureCanvas = ref<HTMLCanvasElement | null>(null);
let ctx: CanvasRenderingContext2D | null = null;
let isDrawing = false;
let hasSignature = ref(false);

// 사직서 제출 가능 여부
const canSubmitResignation = computed(() => {
  return resignationData.value.reason.trim() !== '' && 
         resignationData.value.resignDate !== '' &&
         hasSignature.value;
});

// 서명 캔버스 초기화
const initSignatureCanvas = () => {
  nextTick(() => {
    if (signatureCanvas.value) {
      const canvas = signatureCanvas.value;
      canvas.width = canvas.offsetWidth;
      canvas.height = canvas.offsetHeight;
      ctx = canvas.getContext('2d');
      if (ctx) {
        ctx.strokeStyle = '#000000';
        ctx.lineWidth = 2;
        ctx.lineCap = 'round';
        ctx.lineJoin = 'round';
      }
    }
  });
};

// 마우스 이벤트
const startDrawing = (e: MouseEvent) => {
  if (!ctx) return;
  isDrawing = true;
  const rect = signatureCanvas.value!.getBoundingClientRect();
  ctx.beginPath();
  ctx.moveTo(e.clientX - rect.left, e.clientY - rect.top);
};

const draw = (e: MouseEvent) => {
  if (!isDrawing || !ctx) return;
  const rect = signatureCanvas.value!.getBoundingClientRect();
  ctx.lineTo(e.clientX - rect.left, e.clientY - rect.top);
  ctx.stroke();
  hasSignature.value = true;
};

const stopDrawing = () => {
  isDrawing = false;
};

// 터치 이벤트
const startDrawingTouch = (e: TouchEvent) => {
  e.preventDefault();
  if (!ctx || !signatureCanvas.value) return;
  isDrawing = true;
  const rect = signatureCanvas.value.getBoundingClientRect();
  const touch = e.touches[0];
  ctx.beginPath();
  ctx.moveTo(touch.clientX - rect.left, touch.clientY - rect.top);
};

const drawTouch = (e: TouchEvent) => {
  e.preventDefault();
  if (!isDrawing || !ctx || !signatureCanvas.value) return;
  const rect = signatureCanvas.value.getBoundingClientRect();
  const touch = e.touches[0];
  ctx.lineTo(touch.clientX - rect.left, touch.clientY - rect.top);
  ctx.stroke();
  hasSignature.value = true;
};

// 서명 지우기
const clearSignature = () => {
  if (ctx && signatureCanvas.value) {
    ctx.clearRect(0, 0, signatureCanvas.value.width, signatureCanvas.value.height);
    hasSignature.value = false;
  }
};

// 사직서 다이얼로그 닫기
const closeResignationDialog = () => {
  showResignationWriteDialog.value = false;
  resignationData.value = { reason: '', resignDate: '' };
  clearSignature();
};

// 사직서 다이얼로그 watch
watch(showResignationWriteDialog, (val) => {
  if (val) {
    initSignatureCanvas();
  }
});

// 스낵바
const showSnackbar = ref(false);
const snackbarMessage = ref('');
const snackbarColor = ref('success');

// 사직서 열기
const openResignation = async () => {
  await fetchMyResignation();
  
  if (myResignation.value) {
    // 이미 제출된 사직서가 있음 -> 상세 보기
    showResignationDetailDialog.value = true;
  } else {
    // 사직서 없음 -> 작성 화면
    showResignationWriteDialog.value = true;
    resignationData.value = { reason: '', resignDate: minResignDate.value };
  }
};

// 내 사직서 조회
const fetchMyResignation = async () => {
  try {
    const response = await axios.get(`/api/emp/resignation/${empIdx.value}`, {
      withCredentials: true
    });
    
    if (response.data.success && response.data.data) {
      myResignation.value = response.data.data;
    } else {
      myResignation.value = null;
    }
  } catch (error) {
    console.error('사직서 조회 오류:', error);
    myResignation.value = null;
  }
};

// 사직서 상태 텍스트
const getResignationStatusText = (status: string) => {
  const statusMap: Record<string, string> = {
    'submitted': '제출됨',
    'approved': '승인됨',
    'rejected': '반려됨',
    'pending': '대기중'
  };
  return statusMap[status] || status;
};

// 사직서 상태 클래스
const getResignationStatusClass = (status: string) => {
  return status || 'submitted';
};

// 카테고리 열기
const openCategory = (category: string) => {
  switch (category) {
    case 'contract':
      showContractDialog.value = true;
      fetchContracts();
      break;
    case 'payslip':
      router.push('/emp/payslip');
      break;
    case 'record':
      showNotice('서비스 기록지 기능은 준비 중입니다.');
      break;
    case 'certificate':
      showCertificateDialog.value = true;
      selectedCertType.value = '';
      certPurpose.value = '';
      break;
  }
};

// 근로계약서 조회
const fetchContracts = async () => {
  try {
    contracts.value = [];
  } catch (error) {
    console.error('근로계약서 조회 오류:', error);
  }
};

// 증명서 발급 요청
const requestCertificate = async () => {
  if (!selectedCertType.value) return;
  
  isRequesting.value = true;
  try {
    await new Promise(resolve => setTimeout(resolve, 1000));
    showCertificateDialog.value = false;
    showSuccess('증명서 발급 요청이 완료되었습니다.');
  } catch (error) {
    console.error('증명서 요청 오류:', error);
    showError('증명서 발급 요청에 실패했습니다.');
  } finally {
    isRequesting.value = false;
  }
};

// 사직서 제출
const submitResignation = async () => {
  if (!canSubmitResignation.value) return;
  
  isSubmitting.value = true;
  try {
    const signatureDataUrl = signatureCanvas.value?.toDataURL('image/png') || '';
    
    const response = await axios.post('/api/emp/resignation', {
      emp_idx: empIdx.value,
      emp_code: empCode.value,
      m_sisul_code: sisulCode.value,
      sisul_name: sisulName.value,
      emp_name: empName.value,
      emp_job: empJob.value,
      resign_reason: resignationData.value.reason,
      resign_date: resignationData.value.resignDate,
      submit_date: todayISO,
      signature_data: signatureDataUrl
    }, { withCredentials: true });
    
    if (response.data.success) {
      closeResignationDialog();
      await fetchMyResignation();
      showSuccess('사직서가 제출되었습니다.');
    } else {
      showError(response.data.message || '사직서 제출에 실패했습니다.');
    }
  } catch (error: any) {
    console.error('사직서 제출 오류:', error);
    showError(error.response?.data?.message || '사직서 제출에 실패했습니다.');
  } finally {
    isSubmitting.value = false;
  }
};

// PDF 다운로드
const downloadResignationPDF = () => {
  if (!myResignation.value?.pdf_path) return;
  
  const pdfUrl = `/api/emp${myResignation.value.pdf_path}`;
  window.open(pdfUrl, '_blank');
};

// 사직서 삭제 확인
const confirmDeleteResignation = () => {
  showDeleteConfirmDialog.value = true;
};

// 사직서 삭제
const deleteResignation = async () => {
  if (!myResignation.value) return;
  
  isDeleting.value = true;
  try {
    const response = await axios.delete(
      `/api/emp/resignation/${empIdx.value}/${myResignation.value.id}`,
      { withCredentials: true }
    );
    
    if (response.data.success) {
      showDeleteConfirmDialog.value = false;
      showResignationDetailDialog.value = false;
      myResignation.value = null;
      showSuccess('사직서가 삭제되었습니다.');
    } else {
      showError(response.data.message || '사직서 삭제에 실패했습니다.');
    }
  } catch (error: any) {
    console.error('사직서 삭제 오류:', error);
    showError(error.response?.data?.message || '사직서 삭제에 실패했습니다.');
  } finally {
    isDeleting.value = false;
  }
};

// 최근 문서 조회
const fetchRecentDocuments = async () => {
  try {
    const response = await axios.get(`/api/emp/documents/${empIdx.value}`, {
      withCredentials: true
    });
    
    if (response.data.success) {
      recentDocuments.value = response.data.data || [];
    }
  } catch (error) {
    console.error('문서 조회 오류:', error);
  }
};

// 문서 아이콘 가져오기
const getDocIcon = (type: string) => {
  const icons: Record<string, string> = {
    contract: 'mdi-file-sign',
    payslip: 'mdi-currency-krw',
    record: 'mdi-clipboard-text',
    certificate: 'mdi-certificate',
    resignation: 'mdi-file-remove'
  };
  return icons[type] || 'mdi-file-document';
};

// 날짜 포맷
const formatDate = (dateStr: string) => {
  if (!dateStr) return '';
  const date = new Date(dateStr);
  return `${date.getFullYear()}.${String(date.getMonth() + 1).padStart(2, '0')}.${String(date.getDate()).padStart(2, '0')}`;
};

// 문서 열기
const openDocument = (doc: any) => {
};

// 문서 다운로드
const downloadDocument = (doc: any) => {
  showNotice('다운로드 기능은 준비 중입니다.');
};

// 계약서 보기
const viewContract = (contract: any) => {
  showNotice('계약서 보기 기능은 준비 중입니다.');
};

// 계약서 다운로드
const downloadContract = (contract: any) => {
  showNotice('다운로드 기능은 준비 중입니다.');
};

// 알림 표시
const showSuccess = (message: string) => {
  snackbarMessage.value = message;
  snackbarColor.value = 'success';
  showSnackbar.value = true;
};

const showError = (message: string) => {
  snackbarMessage.value = message;
  snackbarColor.value = 'error';
  showSnackbar.value = true;
};

const showNotice = (message: string) => {
  snackbarMessage.value = message;
  snackbarColor.value = 'info';
  showSnackbar.value = true;
};

// 초기 데이터 로드
onMounted(async () => {
  isLoading.value = true;
  try {
    await fetchMyResignation();
  } catch (error) {
    console.error('문서 조회 오류:', error);
  } finally {
    isLoading.value = false;
  }
});

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_snackbar = _resolveComponent("v-snackbar")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[90] || (_cache[90] = _createElementVNode("div", { class: "app-header" }, [
      _createElementVNode("div", { class: "header-title" }, "문서함")
    ], -1)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", {
          class: "category-card",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (openCategory('contract')))
        }, [
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_v_icon, {
              size: "28",
              color: "white"
            }, {
              default: _withCtx(() => [...(_cache[19] || (_cache[19] = [
                _createTextVNode("mdi-file-sign", -1)
              ]))]),
              _: 1
            })
          ]),
          _cache[21] || (_cache[21] = _createElementVNode("div", { class: "card-content" }, [
            _createElementVNode("h3", null, "근로계약서"),
            _createElementVNode("p", null, "나의 근로계약서 확인")
          ], -1)),
          (documentCounts.value.contract > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(documentCounts.value.contract), 1))
            : _createCommentVNode("", true),
          _createVNode(_component_v_icon, {
            size: "20",
            color: "#9ca3af"
          }, {
            default: _withCtx(() => [...(_cache[20] || (_cache[20] = [
              _createTextVNode("mdi-chevron-right", -1)
            ]))]),
            _: 1
          })
        ]),
        _createElementVNode("div", {
          class: "category-card",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (openCategory('payslip')))
        }, [
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_v_icon, {
              size: "28",
              color: "white"
            }, {
              default: _withCtx(() => [...(_cache[22] || (_cache[22] = [
                _createTextVNode("mdi-currency-krw", -1)
              ]))]),
              _: 1
            })
          ]),
          _cache[24] || (_cache[24] = _createElementVNode("div", { class: "card-content" }, [
            _createElementVNode("h3", null, "급여명세서"),
            _createElementVNode("p", null, "월별 급여명세서 다운로드")
          ], -1)),
          (documentCounts.value.payslip > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(documentCounts.value.payslip), 1))
            : _createCommentVNode("", true),
          _createVNode(_component_v_icon, {
            size: "20",
            color: "#9ca3af"
          }, {
            default: _withCtx(() => [...(_cache[23] || (_cache[23] = [
              _createTextVNode("mdi-chevron-right", -1)
            ]))]),
            _: 1
          })
        ]),
        (isCaregiver.value)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "category-card",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (openCategory('record')))
            }, [
              _createElementVNode("div", _hoisted_8, [
                _createVNode(_component_v_icon, {
                  size: "28",
                  color: "white"
                }, {
                  default: _withCtx(() => [...(_cache[25] || (_cache[25] = [
                    _createTextVNode("mdi-clipboard-text", -1)
                  ]))]),
                  _: 1
                })
              ]),
              _cache[27] || (_cache[27] = _createElementVNode("div", { class: "card-content" }, [
                _createElementVNode("h3", null, "서비스 기록지"),
                _createElementVNode("p", null, "방문일지 및 서비스 기록")
              ], -1)),
              (documentCounts.value.record > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_9, _toDisplayString(documentCounts.value.record), 1))
                : _createCommentVNode("", true),
              _createVNode(_component_v_icon, {
                size: "20",
                color: "#9ca3af"
              }, {
                default: _withCtx(() => [...(_cache[26] || (_cache[26] = [
                  _createTextVNode("mdi-chevron-right", -1)
                ]))]),
                _: 1
              })
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", {
          class: "category-card",
          onClick: _cache[3] || (_cache[3] = ($event: any) => (openCategory('certificate')))
        }, [
          _createElementVNode("div", _hoisted_10, [
            _createVNode(_component_v_icon, {
              size: "28",
              color: "white"
            }, {
              default: _withCtx(() => [...(_cache[28] || (_cache[28] = [
                _createTextVNode("mdi-certificate", -1)
              ]))]),
              _: 1
            })
          ]),
          _cache[30] || (_cache[30] = _createElementVNode("div", { class: "card-content" }, [
            _createElementVNode("h3", null, "증명서 발급"),
            _createElementVNode("p", null, "재직증명서, 경력증명서 요청")
          ], -1)),
          _createElementVNode("div", _hoisted_11, [
            _createVNode(_component_v_icon, {
              size: "20",
              color: "#9ca3af"
            }, {
              default: _withCtx(() => [...(_cache[29] || (_cache[29] = [
                _createTextVNode("mdi-chevron-right", -1)
              ]))]),
              _: 1
            })
          ])
        ]),
        _createElementVNode("div", {
          class: "category-card resignation",
          onClick: openResignation
        }, [
          _createElementVNode("div", _hoisted_12, [
            _createVNode(_component_v_icon, {
              size: "28",
              color: "white"
            }, {
              default: _withCtx(() => [...(_cache[31] || (_cache[31] = [
                _createTextVNode("mdi-file-remove", -1)
              ]))]),
              _: 1
            })
          ]),
          _cache[33] || (_cache[33] = _createElementVNode("div", { class: "card-content" }, [
            _createElementVNode("h3", null, "사직서"),
            _createElementVNode("p", null, "사직서 작성 및 제출")
          ], -1)),
          (myResignation.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                _createElementVNode("span", {
                  class: _normalizeClass(getResignationStatusClass(myResignation.value.status))
                }, _toDisplayString(getResignationStatusText(myResignation.value.status)), 3)
              ]))
            : _createCommentVNode("", true),
          _createVNode(_component_v_icon, {
            size: "20",
            color: "#9ca3af"
          }, {
            default: _withCtx(() => [...(_cache[32] || (_cache[32] = [
              _createTextVNode("mdi-chevron-right", -1)
            ]))]),
            _: 1
          })
        ])
      ]),
      (recentDocuments.value.length > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
            _createElementVNode("h2", _hoisted_15, [
              _createVNode(_component_v_icon, {
                size: "20",
                color: "#059669"
              }, {
                default: _withCtx(() => [...(_cache[34] || (_cache[34] = [
                  _createTextVNode("mdi-clock-outline", -1)
                ]))]),
                _: 1
              }),
              _cache[35] || (_cache[35] = _createTextVNode(" 최근 문서 ", -1))
            ]),
            _createElementVNode("div", _hoisted_16, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(recentDocuments.value, (doc) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: doc.id,
                  class: "document-item",
                  onClick: ($event: any) => (openDocument(doc))
                }, [
                  _createElementVNode("div", {
                    class: _normalizeClass(["doc-icon", doc.type])
                  }, [
                    _createVNode(_component_v_icon, {
                      size: "20",
                      color: "white"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(getDocIcon(doc.type)), 1)
                      ]),
                      _: 2
                    }, 1024)
                  ], 2),
                  _createElementVNode("div", _hoisted_18, [
                    _createElementVNode("span", _hoisted_19, _toDisplayString(doc.name), 1),
                    _createElementVNode("span", _hoisted_20, _toDisplayString(formatDate(doc.date)), 1)
                  ]),
                  _createElementVNode("button", {
                    class: "download-btn",
                    onClick: _withModifiers(($event: any) => (downloadDocument(doc)), ["stop"])
                  }, [
                    _createVNode(_component_v_icon, {
                      size: "18",
                      color: "#059669"
                    }, {
                      default: _withCtx(() => [...(_cache[36] || (_cache[36] = [
                        _createTextVNode("mdi-download", -1)
                      ]))]),
                      _: 1
                    })
                  ], 8, _hoisted_21)
                ], 8, _hoisted_17))
              }), 128))
            ])
          ]))
        : _createCommentVNode("", true),
      (recentDocuments.value.length === 0 && !isLoading.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
            _createVNode(_component_v_icon, {
              size: "48",
              color: "#d1d5db"
            }, {
              default: _withCtx(() => [...(_cache[37] || (_cache[37] = [
                _createTextVNode("mdi-folder-open-outline", -1)
              ]))]),
              _: 1
            }),
            _cache[38] || (_cache[38] = _createElementVNode("p", null, "최근 문서가 없습니다", -1)),
            _cache[39] || (_cache[39] = _createElementVNode("span", null, "카테고리를 선택하여 문서를 확인하세요", -1))
          ]))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_component_v_dialog, {
      modelValue: showContractDialog.value,
      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((showContractDialog).value = $event)),
      "max-width": "450"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, { class: "document-dialog-card" }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_23, [
              _cache[41] || (_cache[41] = _createElementVNode("h3", null, "근로계약서", -1)),
              _createElementVNode("button", {
                class: "close-btn",
                onClick: _cache[4] || (_cache[4] = ($event: any) => (showContractDialog.value = false))
              }, [
                _createVNode(_component_v_icon, null, {
                  default: _withCtx(() => [...(_cache[40] || (_cache[40] = [
                    _createTextVNode("mdi-close", -1)
                  ]))]),
                  _: 1
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_24, [
              (contracts.value.length > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(contracts.value, (contract) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: contract.id,
                        class: "contract-item"
                      }, [
                        _createElementVNode("div", _hoisted_26, [
                          _createElementVNode("span", _hoisted_27, _toDisplayString(contract.period), 1),
                          _createElementVNode("span", _hoisted_28, _toDisplayString(contract.type), 1)
                        ]),
                        _createElementVNode("div", _hoisted_29, [
                          _createElementVNode("button", {
                            class: "view-btn",
                            onClick: ($event: any) => (viewContract(contract))
                          }, [
                            _createVNode(_component_v_icon, { size: "18" }, {
                              default: _withCtx(() => [...(_cache[42] || (_cache[42] = [
                                _createTextVNode("mdi-eye", -1)
                              ]))]),
                              _: 1
                            })
                          ], 8, _hoisted_30),
                          _createElementVNode("button", {
                            class: "download-btn",
                            onClick: ($event: any) => (downloadContract(contract))
                          }, [
                            _createVNode(_component_v_icon, { size: "18" }, {
                              default: _withCtx(() => [...(_cache[43] || (_cache[43] = [
                                _createTextVNode("mdi-download", -1)
                              ]))]),
                              _: 1
                            })
                          ], 8, _hoisted_31)
                        ])
                      ]))
                    }), 128))
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_32, [
                    _createVNode(_component_v_icon, {
                      size: "40",
                      color: "#d1d5db"
                    }, {
                      default: _withCtx(() => [...(_cache[44] || (_cache[44] = [
                        _createTextVNode("mdi-file-document-outline", -1)
                      ]))]),
                      _: 1
                    }),
                    _cache[45] || (_cache[45] = _createElementVNode("p", null, "등록된 근로계약서가 없습니다", -1))
                  ]))
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_v_dialog, {
      modelValue: showCertificateDialog.value,
      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((showCertificateDialog).value = $event)),
      "max-width": "400"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, { class: "document-dialog-card" }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_33, [
              _cache[47] || (_cache[47] = _createElementVNode("h3", null, "증명서 발급 요청", -1)),
              _createElementVNode("button", {
                class: "close-btn",
                onClick: _cache[6] || (_cache[6] = ($event: any) => (showCertificateDialog.value = false))
              }, [
                _createVNode(_component_v_icon, null, {
                  default: _withCtx(() => [...(_cache[46] || (_cache[46] = [
                    _createTextVNode("mdi-close", -1)
                  ]))]),
                  _: 1
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_34, [
              _createElementVNode("div", _hoisted_35, [
                _createElementVNode("button", {
                  class: _normalizeClass(["cert-option", { active: selectedCertType.value === 'employment' }]),
                  onClick: _cache[7] || (_cache[7] = ($event: any) => (selectedCertType.value = 'employment'))
                }, [
                  _createVNode(_component_v_icon, {
                    size: "24",
                    color: selectedCertType.value === 'employment' ? '#059669' : '#9ca3af'
                  }, {
                    default: _withCtx(() => [...(_cache[48] || (_cache[48] = [
                      _createTextVNode(" mdi-badge-account-horizontal ", -1)
                    ]))]),
                    _: 1
                  }, 8, ["color"]),
                  _cache[49] || (_cache[49] = _createElementVNode("span", null, "재직증명서", -1))
                ], 2),
                _createElementVNode("button", {
                  class: _normalizeClass(["cert-option", { active: selectedCertType.value === 'career' }]),
                  onClick: _cache[8] || (_cache[8] = ($event: any) => (selectedCertType.value = 'career'))
                }, [
                  _createVNode(_component_v_icon, {
                    size: "24",
                    color: selectedCertType.value === 'career' ? '#059669' : '#9ca3af'
                  }, {
                    default: _withCtx(() => [...(_cache[50] || (_cache[50] = [
                      _createTextVNode(" mdi-certificate ", -1)
                    ]))]),
                    _: 1
                  }, 8, ["color"]),
                  _cache[51] || (_cache[51] = _createElementVNode("span", null, "경력증명서", -1))
                ], 2)
              ]),
              _createElementVNode("div", _hoisted_36, [
                _cache[52] || (_cache[52] = _createElementVNode("label", null, "발급 용도", -1)),
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((certPurpose).value = $event)),
                  placeholder: "예: 은행 제출용, 관공서 제출용"
                }, null, 512), [
                  [_vModelText, certPurpose.value]
                ])
              ]),
              _createElementVNode("button", {
                class: "request-btn",
                disabled: !selectedCertType.value || isRequesting.value,
                onClick: requestCertificate
              }, [
                (isRequesting.value)
                  ? (_openBlock(), _createBlock(_component_v_progress_circular, {
                      key: 0,
                      indeterminate: "",
                      size: "20",
                      color: "white"
                    }))
                  : (_openBlock(), _createElementBlock("span", _hoisted_38, "발급 요청"))
              ], 8, _hoisted_37),
              _createElementVNode("p", _hoisted_39, [
                _createVNode(_component_v_icon, {
                  size: "14",
                  color: "#d97706"
                }, {
                  default: _withCtx(() => [...(_cache[53] || (_cache[53] = [
                    _createTextVNode("mdi-information-outline", -1)
                  ]))]),
                  _: 1
                }),
                _cache[54] || (_cache[54] = _createTextVNode(" 요청 후 관리자 승인 시 발급됩니다 ", -1))
              ])
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_v_dialog, {
      modelValue: showResignationWriteDialog.value,
      "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((showResignationWriteDialog).value = $event)),
      "max-width": "420"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, { class: "resignation-write-card" }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_40, [
              _createVNode(_component_v_icon, {
                size: "28",
                color: "#dc2626"
              }, {
                default: _withCtx(() => [...(_cache[55] || (_cache[55] = [
                  _createTextVNode("mdi-file-document-edit", -1)
                ]))]),
                _: 1
              }),
              _cache[57] || (_cache[57] = _createElementVNode("h2", null, "사직서 작성", -1)),
              _createElementVNode("button", {
                class: "close-btn",
                onClick: closeResignationDialog
              }, [
                _createVNode(_component_v_icon, { size: "22" }, {
                  default: _withCtx(() => [...(_cache[56] || (_cache[56] = [
                    _createTextVNode("mdi-close", -1)
                  ]))]),
                  _: 1
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_41, [
              _createElementVNode("div", _hoisted_42, [
                _createElementVNode("label", null, [
                  _createVNode(_component_v_icon, {
                    size: "18",
                    color: "#6b7280"
                  }, {
                    default: _withCtx(() => [...(_cache[58] || (_cache[58] = [
                      _createTextVNode("mdi-calendar", -1)
                    ]))]),
                    _: 1
                  }),
                  _cache[59] || (_cache[59] = _createTextVNode(" 퇴사 희망일 ", -1))
                ]),
                _withDirectives(_createElementVNode("input", {
                  type: "date",
                  "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((resignationData.value.resignDate) = $event)),
                  class: "date-input",
                  min: minResignDate.value
                }, null, 8, _hoisted_43), [
                  [_vModelText, resignationData.value.resignDate]
                ]),
                _cache[60] || (_cache[60] = _createElementVNode("p", { class: "input-hint" }, "최소 2주 후 날짜부터 선택 가능합니다", -1))
              ]),
              _createElementVNode("div", _hoisted_44, [
                _createElementVNode("label", null, [
                  _createVNode(_component_v_icon, {
                    size: "18",
                    color: "#6b7280"
                  }, {
                    default: _withCtx(() => [...(_cache[61] || (_cache[61] = [
                      _createTextVNode("mdi-text-box", -1)
                    ]))]),
                    _: 1
                  }),
                  _cache[62] || (_cache[62] = _createTextVNode(" 사직 사유 ", -1))
                ]),
                _withDirectives(_createElementVNode("textarea", {
                  "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((resignationData.value.reason) = $event)),
                  class: "reason-input",
                  placeholder: "사직 사유를 입력하세요",
                  rows: "4"
                }, null, 512), [
                  [_vModelText, resignationData.value.reason]
                ])
              ]),
              _createElementVNode("div", _hoisted_45, [
                _createElementVNode("label", null, [
                  _createVNode(_component_v_icon, {
                    size: "18",
                    color: "#6b7280"
                  }, {
                    default: _withCtx(() => [...(_cache[63] || (_cache[63] = [
                      _createTextVNode("mdi-draw", -1)
                    ]))]),
                    _: 1
                  }),
                  _cache[64] || (_cache[64] = _createTextVNode(" 서명 ", -1))
                ]),
                _createElementVNode("div", _hoisted_46, [
                  _createElementVNode("canvas", {
                    ref_key: "signatureCanvas",
                    ref: signatureCanvas,
                    class: "signature-canvas",
                    onMousedown: startDrawing,
                    onMousemove: draw,
                    onMouseup: stopDrawing,
                    onMouseleave: stopDrawing,
                    onTouchstart: startDrawingTouch,
                    onTouchmove: drawTouch,
                    onTouchend: stopDrawing
                  }, null, 544),
                  _createElementVNode("button", {
                    class: "clear-btn",
                    onClick: clearSignature,
                    type: "button"
                  }, [
                    _createVNode(_component_v_icon, { size: "16" }, {
                      default: _withCtx(() => [...(_cache[65] || (_cache[65] = [
                        _createTextVNode("mdi-refresh", -1)
                      ]))]),
                      _: 1
                    }),
                    _cache[66] || (_cache[66] = _createTextVNode(" 다시 그리기 ", -1))
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_47, [
                _createVNode(_component_v_icon, {
                  size: "16",
                  color: "#0369a1"
                }, {
                  default: _withCtx(() => [...(_cache[67] || (_cache[67] = [
                    _createTextVNode("mdi-information", -1)
                  ]))]),
                  _: 1
                }),
                _cache[68] || (_cache[68] = _createElementVNode("span", null, "제출 시 자동으로 사직서 PDF가 생성됩니다", -1))
              ]),
              _createElementVNode("div", _hoisted_48, [
                _createVNode(_component_v_icon, {
                  size: "16",
                  color: "#dc2626"
                }, {
                  default: _withCtx(() => [...(_cache[69] || (_cache[69] = [
                    _createTextVNode("mdi-alert-circle", -1)
                  ]))]),
                  _: 1
                }),
                _cache[70] || (_cache[70] = _createElementVNode("span", null, "제출 후 삭제는 승인 전까지만 가능합니다", -1))
              ]),
              _createElementVNode("button", {
                class: "submit-btn",
                disabled: !canSubmitResignation.value || isSubmitting.value,
                onClick: submitResignation
              }, [
                (isSubmitting.value)
                  ? (_openBlock(), _createBlock(_component_v_progress_circular, {
                      key: 0,
                      indeterminate: "",
                      size: "20",
                      color: "white"
                    }))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _createVNode(_component_v_icon, { size: "20" }, {
                        default: _withCtx(() => [...(_cache[71] || (_cache[71] = [
                          _createTextVNode("mdi-send", -1)
                        ]))]),
                        _: 1
                      }),
                      _cache[72] || (_cache[72] = _createElementVNode("span", null, "사직서 제출", -1))
                    ], 64))
              ], 8, _hoisted_49)
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_v_dialog, {
      modelValue: showResignationDetailDialog.value,
      "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((showResignationDetailDialog).value = $event)),
      "max-width": "500"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, { class: "resignation-detail-card" }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_50, [
              _cache[74] || (_cache[74] = _createElementVNode("h2", null, "제출된 사직서", -1)),
              _createElementVNode("button", {
                class: "close-btn",
                onClick: _cache[14] || (_cache[14] = ($event: any) => (showResignationDetailDialog.value = false))
              }, [
                _createVNode(_component_v_icon, { color: "white" }, {
                  default: _withCtx(() => [...(_cache[73] || (_cache[73] = [
                    _createTextVNode("mdi-close", -1)
                  ]))]),
                  _: 1
                })
              ])
            ]),
            (myResignation.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_51, [
                  _createElementVNode("div", {
                    class: _normalizeClass(["status-badge", myResignation.value.status])
                  }, _toDisplayString(getResignationStatusText(myResignation.value.status)), 3),
                  _createElementVNode("div", _hoisted_52, [
                    _createElementVNode("div", _hoisted_53, [
                      _cache[75] || (_cache[75] = _createElementVNode("span", { class: "info-label" }, "소속", -1)),
                      _createElementVNode("span", _hoisted_54, _toDisplayString(myResignation.value.content?.sisul_name || sisulName.value), 1)
                    ]),
                    _createElementVNode("div", _hoisted_55, [
                      _cache[76] || (_cache[76] = _createElementVNode("span", { class: "info-label" }, "직위", -1)),
                      _createElementVNode("span", _hoisted_56, _toDisplayString(myResignation.value.content?.emp_job || empJob.value), 1)
                    ]),
                    _createElementVNode("div", _hoisted_57, [
                      _cache[77] || (_cache[77] = _createElementVNode("span", { class: "info-label" }, "성명", -1)),
                      _createElementVNode("span", _hoisted_58, _toDisplayString(myResignation.value.content?.emp_name || empName.value), 1)
                    ]),
                    _createElementVNode("div", _hoisted_59, [
                      _cache[78] || (_cache[78] = _createElementVNode("span", { class: "info-label" }, "사직사유", -1)),
                      _createElementVNode("span", _hoisted_60, _toDisplayString(myResignation.value.content?.resign_reason), 1)
                    ]),
                    _createElementVNode("div", _hoisted_61, [
                      _cache[79] || (_cache[79] = _createElementVNode("span", { class: "info-label" }, "퇴사 희망일", -1)),
                      _createElementVNode("span", _hoisted_62, _toDisplayString(formatDate(myResignation.value.resign_date)), 1)
                    ]),
                    _createElementVNode("div", _hoisted_63, [
                      _cache[80] || (_cache[80] = _createElementVNode("span", { class: "info-label" }, "제출일", -1)),
                      _createElementVNode("span", _hoisted_64, _toDisplayString(formatDate(myResignation.value.submit_date)), 1)
                    ])
                  ]),
                  (myResignation.value.pdf_path)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        class: "download-pdf-btn",
                        onClick: downloadResignationPDF
                      }, [
                        _createVNode(_component_v_icon, { size: "20" }, {
                          default: _withCtx(() => [...(_cache[81] || (_cache[81] = [
                            _createTextVNode("mdi-file-pdf-box", -1)
                          ]))]),
                          _: 1
                        }),
                        _cache[82] || (_cache[82] = _createElementVNode("span", null, "사직서 PDF 다운로드", -1))
                      ]))
                    : _createCommentVNode("", true),
                  (myResignation.value.status === 'submitted')
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 1,
                        class: "delete-btn",
                        onClick: confirmDeleteResignation
                      }, [
                        _createVNode(_component_v_icon, { size: "20" }, {
                          default: _withCtx(() => [...(_cache[83] || (_cache[83] = [
                            _createTextVNode("mdi-delete", -1)
                          ]))]),
                          _: 1
                        }),
                        _cache[84] || (_cache[84] = _createElementVNode("span", null, "사직서 삭제", -1))
                      ]))
                    : _createCommentVNode("", true),
                  (myResignation.value.status !== 'submitted')
                    ? (_openBlock(), _createElementBlock("p", _hoisted_65, [
                        _createVNode(_component_v_icon, {
                          size: "14",
                          color: "#9ca3af"
                        }, {
                          default: _withCtx(() => [...(_cache[85] || (_cache[85] = [
                            _createTextVNode("mdi-information-outline", -1)
                          ]))]),
                          _: 1
                        }),
                        _cache[86] || (_cache[86] = _createTextVNode(" 이미 처리된 사직서는 삭제할 수 없습니다. ", -1))
                      ]))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_v_dialog, {
      modelValue: showDeleteConfirmDialog.value,
      "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((showDeleteConfirmDialog).value = $event)),
      "max-width": "340"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, { class: "confirm-dialog-card" }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_66, [
              _createVNode(_component_v_icon, {
                size: "48",
                color: "#dc2626"
              }, {
                default: _withCtx(() => [...(_cache[87] || (_cache[87] = [
                  _createTextVNode("mdi-alert-circle-outline", -1)
                ]))]),
                _: 1
              }),
              _cache[88] || (_cache[88] = _createElementVNode("h3", null, "사직서 삭제", -1)),
              _cache[89] || (_cache[89] = _createElementVNode("p", null, [
                _createTextVNode("제출한 사직서를 삭제하시겠습니까?"),
                _createElementVNode("br"),
                _createTextVNode("삭제 후에는 복구할 수 없습니다.")
              ], -1))
            ]),
            _createElementVNode("div", _hoisted_67, [
              _createElementVNode("button", {
                class: "cancel-btn",
                onClick: _cache[16] || (_cache[16] = ($event: any) => (showDeleteConfirmDialog.value = false))
              }, "취소"),
              _createElementVNode("button", {
                class: "delete-confirm-btn",
                onClick: deleteResignation,
                disabled: isDeleting.value
              }, [
                (isDeleting.value)
                  ? (_openBlock(), _createBlock(_component_v_progress_circular, {
                      key: 0,
                      indeterminate: "",
                      size: "18",
                      color: "white"
                    }))
                  : (_openBlock(), _createElementBlock("span", _hoisted_69, "삭제"))
              ], 8, _hoisted_68)
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_v_snackbar, {
      modelValue: showSnackbar.value,
      "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((showSnackbar).value = $event)),
      color: snackbarColor.value,
      timeout: 3000
    }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(snackbarMessage.value), 1)
      ]),
      _: 1
    }, 8, ["modelValue", "color"])
  ]))
}
}

})